{
  "id": "001-007",
  "title": "Changing colors",
  "layout": {
    "offset": "even-row",
    "tiles": {
      "0": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "id": "7eaec543"
            }
          ],
          "modifiers": [
            {
              "type": "move",
              "id": "aa1fa035"
            }
          ],
          "id": "f0d256ba"
        },
        "1": {
          "type": "tile",
          "id": "72c3c916",
          "modifiers": [
            {
              "type": "immutable",
              "id": "d3451599"
            }
          ]
        },
        "-2": {
          "type": "tile",
          "id": "0ed739c7",
          "modifiers": [
            {
              "type": "immutable",
              "id": "6959428f"
            }
          ]
        },
        "-1": {
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "id": "f98bee1d"
            }
          ],
          "modifiers": [
            {
              "type": "move",
              "id": "f832a423"
            }
          ],
          "id": "fb4b5a5c"
        }
      },
      "1": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "filter",
              "color": "#ff0000",
              "id": "ce00988d"
            }
          ],
          "id": "fe092f90"
        },
        "1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "direction": 3,
                  "color": "#ff0000"
                }
              ],
              "id": "df42627b"
            }
          ],
          "id": "65654f82"
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#b400b4",
                  "direction": 0
                }
              ],
              "id": "549c64b6"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "e76d0e3e"
            }
          ],
          "id": "16730a74"
        },
        "-1": {
          "type": "tile",
          "modifiers": [
            {
              "type": "rotate",
              "id": "6f8ceb2c"
            }
          ],
          "id": "4f76111a"
        }
      },
      "-1": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#b400b4",
                  "direction": 3
                }
              ],
              "id": "552167d1"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "f4c9837f"
            }
          ],
          "id": "a7d5efb6"
        },
        "-1": {
          "type": "tile",
          "id": "3e72d7db",
          "modifiers": [
            {
              "type": "toggle",
              "id": "11017ae0"
            }
          ]
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "filter",
              "color": "#0000ff",
              "id": "3b12ae82"
            }
          ],
          "id": "41281869"
        },
        "-3": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "direction": 0,
                  "color": "#0000ff"
                }
              ],
              "id": "94852020"
            }
          ],
          "id": "6ce87703"
        }
      }
    },
    "modifiers": [
      {
        "type": "swap",
        "id": "2d33dc20"
      }
    ]
  },
  "version": 0,
  "requirements": [
    {
      "type": "connections",
      "amount": 2
    }
  ]
}
